'use client';

import { useState, Dispatch, SetStateAction } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Navbar from '@/components/layout/Navbar';
import Hamburger from '@/components/layout/mobile/Hamburger';
import { LayoutProps } from '@/types/generalSettings';

type LogoAndNavProps = {
    setLoading: Dispatch<SetStateAction<boolean>>;
    menuItems: any[]; // FIX: Relaxed type to allow extended properties
    logo?: {
        sourceUrl?: string;
        mediaDetails?: { width?: number; height?: number };
    };
    brokerAd?: LayoutProps.BrokersAd[];
    exchangeForeignAd?: LayoutProps.BrokersAd[];
    exchangeIranianAd?: LayoutProps.BrokersAd[];
    propAd?: LayoutProps.BrokersAd[];
    loading: boolean;
    megaMenuContent?: any; // FIX: Added prop
};

export default function LogoAndNav({
    menuItems,
    logo,
    brokerAd,
    exchangeForeignAd,
    exchangeIranianAd,
    propAd,
    loading,
    setLoading,
    megaMenuContent,
}: LogoAndNavProps) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            <Hamburger isOpen={isMenuOpen} setOpen={setIsMenuOpen} />
            <Link
                href='/'
                className='w-32 max-lg:px-1 h-7 max-lg:absolute max-lg:top-1/2 max-lg:right-1/2 max-lg:-translate-y-1/2 max-lg:translate-x-1/2 aspect-video lg:ml-4'
            >
                {logo?.sourceUrl && (
                    <Image
                        // Shown at 128px (w-32): without sizes an 828px file was fetched, and as
                        // `priority` it was preloaded on every page ahead of the page's main image.
                        loading='eager'
                        sizes='128px'
                        width={logo.mediaDetails?.width}
                        height={logo.mediaDetails?.height}
                        src={logo.sourceUrl}
                        alt='خانه سرمایه'
                        className='w-full object-contain dark:grayscale dark:invert'
                    />
                )}
            </Link>

            {/* FIX: Pass megaMenuContent down */}
            <Navbar
                setLoading={setLoading}
                brokerAd={brokerAd}
                exchangeForeignAd={exchangeForeignAd}
                exchangeIranianAd={exchangeIranianAd}
                propAd={propAd}
                isOpen={isMenuOpen}
                setOpen={setIsMenuOpen}
                loading={loading}
                logo={logo}
                menuItems={menuItems}
                megaMenuContent={megaMenuContent}
            />
        </>
    );
}
